const dentureOrderRoutes = [
    {
        path:'list',
        name:'denture-order-list',
        redirect: { name: 'denture-order-list-waitConfirm' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/tables/list.vue'),
        children:[{
            path:'waitConfirm',
            name:'denture-order-list-waitConfirm',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/tables/waitConfirm/waitConfirm.vue')
        },{
            path:'processing',
            name:'denture-order-list-processing',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/tables/processing.vue')
        },{
            path:'close',
            name:'denture-order-list-close',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/tables/close.vue')
        },{
            path:'search',
            name:'denture-order-list-search',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/tables/search.vue')
        }]
    },
    
    {
        path:'detail/:order_sn_id',
        name:'denture-order-info',
        component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/detail/index.vue'),
        redirect: { name: 'denture-order-info-form' },
        children:[{
            path:'form',
            name:'denture-order-info-form',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/detail/form.vue')
        },{
            path:'setting',
            name:'denture-order-info-setting',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/detail/setting.vue')
        },{
            path:'history',
            name:'denture-order-info-history',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/detail/history.vue')
        }]
    },
    {
        path:'edit/:order_sn_id',
        name:'denture-order-edit',
        component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/edit/edit.vue'),
        redirect: { 
            name: 'denture-order-edit-modified' 
        },
        children:[{
            path:'modified',
            name:'denture-order-edit-modified',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/edit/modified.vue')
        },{
            path:'original',
            name:'denture-order-edit-original',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/edit/original.vue')
        }]

    },{
        path:'redo/:order_sn_id',
        name:'denture-order-redo',
        component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/redo/redo.vue'),
        redirect: { 
            name: 'denture-order-redo-modified' 
        },
        children:[{
            path:'modified',
            name:'denture-order-redo-modified',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/redo/modified.vue')
        },{
            path:'original',
            name:'denture-order-redo-original',
            component: () => import(/* webpackChunkName: "about" */ '@/views/dentureOrder/redo/original.vue')
        }]

    },
    

]
export default dentureOrderRoutes